import { render, staticRenderFns } from "./UploadFile.vue?vue&type=template&id=065dbf43&scoped=true"
import script from "./UploadFile.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadFile.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UploadFile.vue?vue&type=style&index=0&id=065dbf43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065dbf43",
  null
  
)

export default component.exports